/* unplugin-vue-components disabled */import { render } from "./UnCollateralNode.vue?vue&type=template&id=ac2c028c"
import script from "./UnCollateralNode.vue?vue&type=script&lang=js"
export * from "./UnCollateralNode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__